import React from 'react';
import InvQuote from '../../accounting/invoice/InvQuote';

// This wrapper allows you to use the invoice/quote form in the trade job context
// Pass props as needed to control behavior (e.g., type, item, onSave, onCancel)
export default function TradeJobCreateInvoiceView(props) {
  return <InvQuote type="invoice" {...props} />;
}
